<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Atenção Primaria à Saúde</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="temAps || clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>
    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-botao
        class="fonte-secundaria texto"
        @click="toggleModal"
        :altura="25"
        :largura="150"
        v-show="temAps || clickSwitch"
        :desabilitado="apsHabilitado"
      >
        Editar APS
      </unicom-botao>
    </unicom-coluna>
    <questionario-aps-vue :visivel="open" @fechar="toggleModal" />
    <div v-if="open">
      <button @click="toggleModal" />
    </div>
  </unicom-linha>
</template>

<script>
import QuestionarioApsVue from "@/views/RecursosPropriosQuestionarios/APS/QuestionarioAPS.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    QuestionarioApsVue
  },
  data() {
    return {
      payload: {
        tipoServico: "Atenção Primária à Saúde"
      },
      open: false
    };
  },
  methods: {
    toggleModal() {
      this.open = !this.open;
    }
  },
  computed: {
    apsHabilitado() {
      return !this.$store.getters.getHablilitarAps;
    },
    temAps() {
      return this.$store.getters.getTemAps;
    }
  }
};
</script>
